import { OrderSummary } from "interfaces/front/OrderListOutput";
import dynamic from "next/dynamic";
import React, { FC, useMemo } from "react";
import { Props as RemainingTextProps } from "../layout/RemainingText";
import { Rating } from "../layout/Rating";
import styled from "styled-components";
import { Card, DetailLiteral, DetailLiteralSub, ImageArea, ItemTextArea, TextBackground, Thumbnail } from "../layout/Card";
import useShowsSupportAmount from "lib/hooks/useShowsSupportAmount";

const RemainingText = dynamic<RemainingTextProps>(() => import("../layout/RemainingText"), { ssr: false });

const OrderItemArea: FC<{
  orderSummary: OrderSummary;
  isShopping?: boolean;
  onClick: () => void;
}> = ({ orderSummary, isShopping, onClick }) => {
  const project = orderSummary.project;
  const courseCount = useMemo(() => {
    return new Set(orderSummary.order.order_details.map((detail) => detail.course_id)).size;
  }, [orderSummary]);
  const hasGoal = useMemo(() => project.goal_amount !== null, [project]);
  const showsSupportAmount = useShowsSupportAmount(project.support_amount);
  return (
    <Root onClick={onClick}>
      <ImageArea>
        <Thumbnail imageUrl={project.content.main_content_images[0].url} hasGoal={hasGoal} />
        <Rating goal={project.goal_amount} support={project.support_amount} />
      </ImageArea>
      <ItemTextArea>
        <TextBackground />
        <DetailLiteral>{project.content.title}</DetailLiteral>
        <DetailLiteral>
          {courseCount > 1 ? `${courseCount}コースを同時購入` : orderSummary.order.order_details[0].course_name}
        </DetailLiteral>
        <DetailLiteralSub showsSupportAmount={showsSupportAmount}>
          {!isShopping && <span style={{ marginRight: "30px" }}>{project.support_amount?.toLocaleString() ?? "?"} 円</span>}
          <RemainingText supportEndAt={project.support_end_at} />
        </DetailLiteralSub>
      </ItemTextArea>
    </Root>
  );
};
export default OrderItemArea;

const Root = styled(Card)`
  margin-bottom: 10px;
`;

